import { Anchor, Text } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import { useRoutingControllerPlzVorschlag } from '@werkbank/shared';

/**
 * Faruq 2026-10-30: Seebold-Aufträge kommen ohne PLZ. Ist die PLZ leer und die
 * Straße mit Hausnummer eingetragen, schlägt das Feld eine PLZ vor (Daten
 * OpenStreetMap über den Routing-Dienst der km-Automatik; es geht nur die
 * Adresse raus). Übernommen wird nur auf Klick — bei leerem Ort auch der Ort.
 */
export function PlzVorschlag({
  street,
  city,
  zip,
  onUebernehmen,
}: {
  street: string;
  city: string;
  zip: string;
  onUebernehmen: (v: { zip: string; city?: string }) => void;
}) {
  // Als EIN Text entprellt — ein Objekt wäre bei jedem Rendern „neu".
  const [schluessel] = useDebouncedValue(`${street.trim()}\n${city.trim()}`, 600);
  const [fStreet = '', fCity = ''] = schluessel.split('\n');
  const frage = { street: fStreet, city: fCity };
  // Erst fragen, wenn eine Hausnummer dasteht — sonst rät der Dienst eine
  // beliebige PLZ der Straße.
  const aktiv = zip.trim() === '' && frage.street.length >= 5 && /\d/.test(frage.street);
  const q = useRoutingControllerPlzVorschlag(
    { street: frage.street, ...(frage.city ? { city: frage.city } : {}) },
    { query: { enabled: aktiv, staleTime: Infinity, retry: false } },
  );
  const v = q.data?.vorschlag;
  if (!aktiv || !v) return null;
  const ortFehlt = city.trim() === '' && v.city !== '';
  return (
    <Text size="xs" c="dimmed" data-testid="plz-vorschlag">
      Vorschlag: {v.zip}
      {v.city ? ` ${v.city}` : ''}
      {v.genau ? '' : ' (nur Straße erkannt)'} ·{' '}
      <Anchor
        component="button"
        type="button"
        size="xs"
        onClick={() => onUebernehmen(ortFehlt ? { zip: v.zip, city: v.city } : { zip: v.zip })}
        data-testid="plz-vorschlag-uebernehmen"
      >
        übernehmen
      </Anchor>
    </Text>
  );
}
